import { Injectable } from "@angular/core";
import { ICacheEntry } from "../../api/dto/cache/icache-entry";
import { ICache } from "../../api/dto/cache/icache";

@Injectable({ providedIn: 'root' })
export class CacheService<T> implements ICache<T> {

    private cache: Map<string, ICacheEntry<T>> = new Map();

    get(key: string): T | undefined {
        const cachedEntry = this.cache.get(key);
        if (!cachedEntry) {
            return undefined;
        }

        if (cachedEntry.tempoExpiracao && cachedEntry.tempoExpiracao < Date.now()) {
            this.remover(key);
            return undefined;
        }

        return cachedEntry.valor;
    }

    set(key: string, valor: T, expiration?: number): void {
        const cacheEntry: ICacheEntry<T> = {
            valor,
            tempoExpiracao: expiration ? Date.now() + expiration : undefined,
        };
        this.cache.set(key, cacheEntry);
    }

    remover(key: string): void {
        this.cache.delete(key);
    }

    limpar(): void {
        this.cache.clear();
    }
}